// extracted by mini-css-extract-plugin
export default {"productTypesList":"LkmRegionList_productTypesList__ubs3D","productTypesList__item":"LkmRegionList_productTypesList__item__KwCjB"};